<template>
	<div class="input_container">
		<i :class="'pre_icon iconfont ' + pre_icon"></i>
		<input
			v-bind:value="value"
			class="input_el"
			ref="input_el"
			@focus="inputFocus"
			@blur="inputBlur"
			maxlength="4"
			@input="$emit('input', $event.target.value)"
			:placeholder="placeholder"
		/>
		<button class="btn verify_btn" @click="getCode" v-loading="loading">
			{{ count === 60 ? $t('user.forget.verify') : count + " s" }}
		</button>
		<i
			class="iconfont icon-deletorerror delete_icon"
			@click="value = ''"
			v-show="showDeleteIcon"
		></i>
	</div>
</template>
<script>
import _ from "lodash";
export default {
	props: ["placeholder", "value", "pre_icon"],
	data() {
		return {
			timer: null,
			count: 60,
			interval: null,
			showDeleteIcon: false,
			loading: false,
		};
	},
	methods: {
		getCode: _.throttle(function () {
			if (this.count === 60) {
			this.$emit("sendCode");
			}
		}, 1000),
		reset() {
			clearInterval(this.interval);
			this.interval = null;
			this.count = 60;
		},
		countDown() {
			this.reset();
			this.interval = setInterval(() => {
				if (this.count == 0) {
					this.reset();
					return;
				}
				this.count--;
			}, 1000);
		},
		inputFocus() {
			this.showDeleteIcon = true;
		},
		inputBlur() {
			this.timer = setTimeout(() => {
				this.showDeleteIcon = false;
			}, 400);
		},
		clearInput() {
			this.$emit("input", "");
			this.$refs.input_el.focus();
		},
	},
	destroyed() {
		clearTimeout(this.timer);
		this.timer = null;
		this.reset();
	},
};
</script>
<style lang="scss" scoped>
input {
	width: 100%;
	font-size: 1.7rem;
	font-weight: 400;
	color: #333333;
	line-height: 2.4rem;
	padding: 1.2rem 4.7rem 1.2rem 4.3rem;
	border: none;
	border-bottom: 0.1rem solid rgba(222, 222, 222, 1);
	background-color: transparent;
	&::placeholder {
		color: rgba(51, 51, 51, 0.1);
	}
}
.input_container {
	position: relative;
	margin-bottom: 2rem;
	.input_el {
		padding-right: 10rem;
	}
	.verify_btn {
		position: absolute;
		right: 1rem;
		background-color: #DC472A;
		padding: 0.5rem 1rem;
		border-radius: 4px;
		color: #fff;
		top: 50%;
		transform: translateY(-50%);
	}
	.pre_icon {
		position: absolute;
		left: 1rem;
		top: 47%;
		transform: translateY(-50%);
		border-right: 0.1rem solid #ddd;
		padding-right: 1rem;
	}
	.delete_icon {
		cursor: pointer;
		position: absolute;
		right: 11rem;
		top: 50%;
		color: #888;
		transform: translateY(-50%);
	}
}
</style>
